import { baseApi } from "../api/baseApi";

export const serverLogsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getServerLogs: build.query({
      query: ({ date, level, page, user, logger, q } = {}) => {
        const params = {};
        if (date) {
          params.date = date;
        }
        if (level) {
          params.level = level;
        }
        if (page) {
          params.page = page;
        }
        if (user) {
          params.user = user;
        }
        if (logger) {
          params.logger = logger;
        }
        const search = String(q ?? "").trim();
        if (search) {
          params.q = search;
        }
        return {
          url: "/api/server-logs",
          method: "GET",
          params,
        };
      },
      providesTags: ["ServerLogs"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetServerLogsQuery } = serverLogsApi;
